var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"video",attrs:{"src":_vm.video_url,"controls":"controls"}},[_vm._v(" 您的浏览器不支持 video 标签。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }